<div class="popup">
    <div class="modal-header">
        <div class="modal-headerTitle" style="padding-left:10px; padding-top:10px; color:red; width:100%; font-size:24px;">Calculation Type Changed</div>
    </div>
    <div class="modal-body" style="padding:10px;margin-bottom:70px;">
        You have changed the Gradebook Calculation Preference and one or more of the sections has assignment scores. You may need to open each gradebook and save it in order for these changes to take affect.
    </div>    
    <div class="sis-app-footer">
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</div>
        
    
    